import React from "react";
import { number } from "prop-types";

import { getTime } from "../../utils";

import "./PublishDateAndTime.m.css";

const PublishDateAndTime = ({ publishTime }) => {
  const convertedDateAndTime = getTime(publishTime);
  return (
    <time dateTime={convertedDateAndTime} className="publish-date-and-time" styleName="publish-date-and-time">
      {convertedDateAndTime}
    </time>
  );
};

PublishDateAndTime.defaultProps = {
  publishTime: 0,
};

PublishDateAndTime.propTypes = {
  publishTime: number.isRequired,
};

export default PublishDateAndTime;
